// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"fbf1f64b","615":"fbf1f64b"}[chunkId] + ".chunk.css";
};